import { Nav } from "./nav";
import { Header } from "./header";
import { Menu } from "./menu";
import { Visit } from "./visit";
import { Slider } from "./slider";
import { Test } from "./test";
import { Footer } from "./footer";

function App() {
  return (
    <div className="App">
      <Nav />
      <Header />
      <Menu />
      <Visit />
      <Slider />
      <Test />
      <Footer />
    </div>
  );
}

export default App;
